export default class EventTypeEnum {
    static  ALL = 'any';
    static  ONLINE = 'online';
    static  OFFLINE = 'offline';
}
